export enum IconViewSizes {
  Auto = 'auto',
  Big = 'big',
  Large = 'large',
  MLarge = 'mlarge',
  XLarge = 'xlarge',
  XXLarge = 'xxlarge',
  Huge = 'huge',
  Medium = 'medium',
  Small = 'small',
  XSmall = 'xsmall',
}
